import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';
import { Store } from '../store';
import { catchError, map } from 'rxjs/operators';
import { ApiAuthHttpClient } from '../http/ApiAuthHttpClient';

@Injectable({
    providedIn: 'root'
})
export class DomainService {
    env = environment;

    constructor(
        private apiService: ApiService,
        private http: ApiAuthHttpClient,
        private store: Store,
    ) {
    }

    findOne(id) {
        return this.http.get(this.env.apiPath + 'domains/' + id, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {

                    return data;
                },
                    catchError(this.apiService.handleError)
                ));
    }

    findAll() {

        return this.http.get(this.env.apiPath + 'domains/all/', this.apiService.getHttpOptions()).subscribe((data: any) => {
            this.store.set('domains', data.data);
        })
    }


}
